import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { fmtFecha } from "../../lib/format";
import { StatusBadge } from "../StatusBadge";
import { Button } from "../ui/button";

const RES = { sin_coincidencia: "ok", posible_coincidencia: "pendiente_verificacion", lista_no_disponible: "fallido" };

export const VersionLista = ({ v }) => (
  <span className="font-mono text-[11px] text-slate-500">{v ? `versión ${fmtFecha(v.fecha)} · hash ${v.hash.slice(0, 12)}…` : "sin versión descargada"}</span>
);

export const ScreeningResults = ({ clientId }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/company/screening", { params: { client_id: clientId } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [clientId]);
  useEffect(() => {
    load();
  }, [load]);
  const run = async () => {
    try {
      await api.post(`/company/clientes/${clientId}/screening`);
      toast.success("Búsqueda en listas ejecutada");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-2 border-t pt-3" data-testid="screening-results">
      <div className="flex items-center gap-3">
        <b className="text-sm">Listas ONU, OFAC y PEP</b>
        <Button size="sm" variant="outline" onClick={run} data-testid="screening-run-button">Buscar ahora</Button>
      </div>
      {!items.length && <p className="text-xs text-slate-500">Aún no hay búsquedas para este cliente.</p>}
      {items.slice(0, 12).map((r) => (
        <div key={r.id} className="text-xs flex flex-wrap items-center gap-2 border-b border-slate-100 pb-1" data-testid={`screening-row-${r.id}`}>
          <span className="w-24 font-semibold uppercase">{r.fuente}</span>
          <StatusBadge value={RES[r.resultado]} label={r.resultado} />
          <span>{fmtFecha(r.fecha)} · {r.motivo}</span>
          {r.fuente === "didit_aml" ? (
            <span className="text-[11px] text-slate-500" data-testid={`screening-didit-${r.id}`}>Didit: {r.estado_didit} · {r.total_didit} hit(s)</span>
          ) : (
            <VersionLista v={r.version_lista} />
          )}
          {r.coincidencias.length > 0 && <span>{r.coincidencias.length} coincidencia(s), máx. {r.coincidencias[0].puntaje}</span>}
          {r.revision && <span className="text-slate-700">Revisado: {r.revision.decision} · {r.revision.nombre}</span>}
        </div>
      ))}
    </div>
  );
};
